export default __webpack_public_path__ + "a2923b1264061ec3817e4514c307cee1.svg";